import Plyr from 'plyr'
import log from 'salvo-lite/log'

class Audio {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const player = new Plyr(this._elem)
        log.debug(this.constructor.name, 'Initiated', player)
    }
}

export default Audio



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Audio.js